/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CommunityGuidelinesContainer_settings = {
    readonly communityGuidelines: {
        readonly enabled: boolean;
        readonly content: string | null;
    };
    readonly " $refType": "CommunityGuidelinesContainer_settings";
};
export type CommunityGuidelinesContainer_settings$data = CommunityGuidelinesContainer_settings;
export type CommunityGuidelinesContainer_settings$key = {
    readonly " $data"?: CommunityGuidelinesContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"CommunityGuidelinesContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunityGuidelinesContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "CommunityGuidelines",
            "kind": "LinkedField",
            "name": "communityGuidelines",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '70a8ac98e9c78f007bbb46bc58d8475d';
export default node;
